import React, { useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from 'axios';

const EditLeaveType = ({ show, onClose, id, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  
  const [name, setName] = useState(''); 
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false); 
  const [nameError, setNameError] = useState(false);
  const [error, setError] = useState(null);

  // Capitalize first letter of each word
  const capitalizeWords = (str) => str.replace(/\b\w/g, char => char.toUpperCase());

  // Reset form and errors on modal close
  useEffect(() => {
    if (!show) {
      setName('');
      setDescription('');
      setNameError(false);
      setError(null);
    }
  }, [show]);

  // Fetch leave type details when modal is shown and id is set
  useEffect(() => {
    if (show && id) {
      setLoading(true);
      axios.get(`${baseURL}/manage-leavetype/${id}`)
        .then(res => {
          const data = res.data?.data;
          if (data) {
            setName(data.leavetype_name || '');
            setDescription(data.description || '');
          }
        })
        .catch(err => {
          console.error('Fetch error:', err);
          alert("Failed to load leave type details.");
        })
        .finally(() => setLoading(false));
    }
  }, [show, id, baseURL]);

  const handleNameChange = (e) => {
    const value = capitalizeWords(e.target.value);
    setName(value);
    setNameError(!value.trim());
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleUpdate = async () => {
    setError(null);
    if (!name.trim()) {
      setNameError(true);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.put(`${baseURL}/manage-leavetype/${id}`, {
        leavetype_name: name,
        description: description,
      });

      if (response.status === 200) {
        onUpdated();
        onClose();
      }
    } catch (err) {
      console.error('Update failed:', err);
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Failed to update leave type.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Leave Type</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Leave Type<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${nameError ? 'is-invalid' : ''}`}
                placeholder="Enter Leave Type"
                value={name}
                onChange={handleNameChange}
                disabled={loading}
              />
              {nameError && <div className="invalid-feedback">Leave Type is required</div>}
            </div>
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={3}
                className="form-control h-auto"
                placeholder="Description"
                value={description}
                onChange={handleDescriptionChange}
                disabled={loading}
              />
            </div>
          </div>
          {error && <div className="text-danger mb-2">{error}</div>}
          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={handleUpdate} disabled={loading}>
              {loading ? 'Updating...' : 'Update Leave Type'}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditLeaveType;
